export default {
	"RecommendGoods.rise": "起",
	"RecommendGoods.purchase": "購買"
}